export const formatDate = (date) => {
  if (!date) return 'N/A';
  
  try {
    // Handle both date string and Date object
    let d;
    
    // If it's already a Date object
    if (date instanceof Date) {
      d = date;
    } else if (typeof date === 'string') {
      // Try to parse the date string
      if (date.includes('T')) {
        // ISO format
        d = new Date(date);
      } else if (date.includes('-')) {
        // YYYY-MM-DD format
        const [year, month, day] = date.split('-');
        d = new Date(year, month - 1, day);
      } else if (date.includes('/')) {
        // MM/DD/YYYY format
        const [month, day, year] = date.split('/');
        d = new Date(year, month - 1, day);
      } else {
        // Try direct parsing
        d = new Date(date);
      }
    } else {
      console.warn('Invalid date format:', date);
      return 'N/A';
    }
    
    // Check if date is invalid
    if (isNaN(d.getTime())) {
      console.warn('Invalid date:', date);
      return 'N/A';
    }
    
    // Format the date with time
    return d.toLocaleString('en-PH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'N/A';
  }
};

// Add a new function for formatting date only (without time)
export const formatDateOnly = (date) => {
  if (!date) return 'N/A';
  
  try {
    // Use the same parsing logic as formatDate
    let d;
    
    if (date instanceof Date) {
      d = date;
    } else if (typeof date === 'string') {
      if (date.includes('T')) {
        d = new Date(date);
      } else if (date.includes('-')) {
        const [year, month, day] = date.split('-');
        d = new Date(year, month - 1, day);
      } else if (date.includes('/')) {
        const [month, day, year] = date.split('/');
        d = new Date(year, month - 1, day);
      } else {
        d = new Date(date);
      }
    } else {
      console.warn('Invalid date format:', date);
      return 'N/A';
    }
    
    if (isNaN(d.getTime())) {
      console.warn('Invalid date:', date);
      return 'N/A';
    }
    
    // Format the date without time
    return d.toLocaleDateString('en-PH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'N/A';
  }
};

export const formatPaymentDate = (date) => {
  if (!date) return 'N/A';
  
  try {
    //console.log('Formatting payment date:', {
    //  input: date,
    //  type: typeof date
    //});

    // Handle both date string and Date object
    let d;
    
    // If it's already a Date object
    if (date instanceof Date) {
      d = date;
    } else if (typeof date === 'string') {
      // Try to parse the date string
      if (date.includes('T') || date.includes(' ')) {
        // ISO format or YYYY-MM-DD HH:MM:SS format
        d = new Date(date.replace(' ', 'T'));
      } else if (date.includes('-')) {
        // YYYY-MM-DD format
        const [year, month, day] = date.split('-');
        d = new Date(year, month - 1, day);
      } else if (date.includes('/')) {
        // MM/DD/YYYY format
        const [month, day, year] = date.split('/');
        d = new Date(year, month - 1, day);
      } else {
        // Try direct parsing
        d = new Date(date);
      }
    } else {
      console.warn('Invalid date format:', date);
      return 'N/A';
    }
    
    // Check if date is invalid
    if (isNaN(d.getTime())) {
      console.warn('Invalid date:', date);
      return 'N/A';
    }
    
    //console.log('Parsed date object:', d);
    
    // Format the date without time
    return d.toLocaleDateString('en-PH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting payment date:', error);
    return 'N/A';
  }
};

export const formatPrice = (value) => {
  if (!value && value !== 0) return '0.00';
  const num = Number(value);
  // Format with commas and fixed 2 decimal places
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatCurrency = (value) => {
  if (!value && value !== 0) return '₱0.00';
  const num = Number(value);
  return `₱${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};